import { render, staticRenderFns } from "./myvideo.vue?vue&type=template&id=51e584be&"
import script from "./myvideo.vue?vue&type=script&lang=ts&"
export * from "./myvideo.vue?vue&type=script&lang=ts&"
import style0 from "./myvideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports